export const getSearchInputWidth = (state: any) => state.searchInput.inputWidth;
